import React, { useEffect, useRef, useState } from "react";
import Avatar from "./Avatar";
import uploadFile from "../helper/uploadFiles";
import Divider from "./Divider";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { LogoutUser } from "../redux/slices/auth";
function EditUserDetails({ onClose }) {
  const uploadPhotoRef = useRef();

  const dispatch = useDispatch();
  const {user}= useSelector((state)=>state.auth)
  const [data, setData] = useState({
    firstName:user?.firstName,
    profile_pic: user?.profile_pic,
  });

  useEffect(() => {
    setData((prev) => {
      return {
        ...prev,
        
      };
    });
  }, []);
   const handleOnChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  }; 

  

  const handleUploadPhoto = async (e) => {
    const file = e.target.files[0];
    const uploadPhoto = await uploadFile(file);
    
    setData((prev) => {
      return { ...prev, profile_pic: uploadPhoto?.url };
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      toast.info("Please wait it will take sometime...", {
        position: "bottom-center",
        autoClose: 50000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
        })
    const URL = `https://gemxbackend.onrender.com/user/updateUserDetails`;
      const response = await axios({
        method: "post",
        url: URL,
        data: {
          firstName: data?.firstName,
          profile_pic: data?.profile_pic,
        },
        withCredentials: true,
      });
      /* toast.success(response.data.message); */
      if (response.data.success) {
       dispatch(LogoutUser())
        onClose();
      }
    } catch (error) {
      
      toast.error(error.response.data.message);
    }
  };
  const handleOpenUploadPhoto = (e) => {
    e.preventDefault();
    e.stopPropagation();
    uploadPhotoRef.current.click();
  };

  return (
    <div className="fixed z-10 top-0 bottom-0 left-0 right-0 bg-slate-400 bg-opacity-40 flex justify-center items-center">
      <div className="bg-slate-100 dark:bg-slate-900 p-4 m-6 rounded w-full max-w-sm">
        <h2 className="font-semibold">Profile Details</h2>
        {/* <p className="text-sm">EditUserDetails</p> */}
        <form className="grid gap-3 mt-3" onSubmit={handleSubmit}>
          <div className="flex flex-col gap-1">
            <label htmlFor="name">Name:</label>
            <input
            autoComplete="off"
              type="text"
              name="firstName"
              id="firstName"
              value={data?.firstName}
              onChange={handleOnChange}
              className="w-full py-1 px-2 dark:bg-black focus:outline-primary dark:focus-within:bg-black bg-slate-200 border-0.5"
            />
          </div>
          <div>
           <div>Photo</div>
            <div className="my-1 flex items-center gap-4">
              <Avatar
                width={40}
                height={40}
                imageUrl={data?.profile_pic}
                name={data?.firstName}
              />
               <label htmlFor="profile_pic">
              <button
                className="font-semibold"
                onClick={handleOpenUploadPhoto}
                
              >
                Change Photo
              </button>
            
              <input
                type="file"
                id="profile_pic"
                className="hidden"
                onChange={handleUploadPhoto}
                ref={uploadPhotoRef}
              />
                </label>
            </div>
            
          </div>
          <Divider />
          <div
            className="flex
             gap-2 w-fit ml-auto mt-3"
          >
            <button
              onClick={onClose}
              className="border-primary text-primary border px-3 py-1 rounded hover:bg-stone-500 hover:text-white"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              className="border-primary bg-primary text-white  border px-3 py-1 rounded hover:bg-stone-500"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default React.memo(EditUserDetails);
